import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'

export const createModalTitle = (title) => (
  <Translate>
    {(t) => (
      <div className="text-center text-color-000 font-bold uppercase">
        {_.isString(title) ? t(title) : title}
      </div>
    )}
  </Translate>
)
